// extracted by mini-css-extract-plugin
export var section = "privacy-module--section--7I+5e";